import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { viewUserVariantEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getVariantsList = createApi(viewUserVariantEndpoint, "GET");

const getVariantsListSlice = createSlice({
  name: "GetVariantsListSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariantsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVariantsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getVariantsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getVariantsListSlice.reducer;
